import { render, staticRenderFns } from "./TagContect.vue?vue&type=template&id=3334a396&scoped=true"
import script from "./TagContect.vue?vue&type=script&lang=js"
export * from "./TagContect.vue?vue&type=script&lang=js"
import style0 from "./TagContect.vue?vue&type=style&index=0&id=3334a396&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3334a396",
  null
  
)

export default component.exports